import React from "react";
import { Box, Typography, Button, Container, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LockIcon from "@mui/icons-material/Lock";

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        flexDirection="column"
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: 2,
          }}
        >
          <LockIcon
            sx={{
              fontSize: 80,
              color: "error.main",
              mb: 2,
            }}
          />

          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            {t("common.unauthorized")}
          </Typography>

          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            {t("common.unauthorizedMessage")}
          </Typography>

          <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
            {t("common.unauthorizedHint")}
          </Typography>

          <Box display="flex" gap={2} justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/timetracking")}
            >
              {t("common.goHome")}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate(-1)}
            >
              {t("common.goBack")}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default UnauthorizedPage;
